import {Component , OnInit} from '@angular/core';

import {AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators} from '@angular/forms';
import {FuseConfigService} from '../../../../../core/services/config.service';
import {fuseAnimations} from '../../../../../core/animations';
import {ActivatedRoute , Router} from '@angular/router';
import {map} from 'rxjs/operators';
import {TranslateService} from '@ngx-translate/core';

export const passwordRequirementsValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const value = control.value;
  if (!value) {
    return null;
  }
  const hasMinLength = value.length >= 12;
  const hasNumber = /\d/.test(value);
  const hasSpecialChar = /[^a-zA-Z0-9]/.test(value);

  if (!hasMinLength || !hasNumber || !hasSpecialChar) {
    return {
      passwordRequirements: {
        hasMinLength,
        hasNumber,
        hasSpecialChar
      }
    };
  }
  return null;
};

@Component({
    selector: 'fuse-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss'],
    animations: fuseAnimations,
    standalone: false
})
export class FuseResetPasswordComponent implements OnInit {
  hash;
  email;
  resetPasswordForm: FormGroup;
  resetPasswordFormErrors: any;
  logoUrl = 'assets/images/logos/fuse.svg';


  constructor (private fuseConfig: FuseConfigService ,
               private formBuilder: FormBuilder ,
               private route: ActivatedRoute,
               private router: Router,
               private translate: TranslateService) {
    this.fuseConfig.setSettings({
      layout: {
        navigation: 'none' ,
        toolbar: 'none' ,
        footer: 'none'
      }
    });

    this.resetPasswordFormErrors = {
      email: {} ,
      password: {} ,
      passwordConfirm: {}
    };
    this.fuseConfig.projectSettings.subscribe((res: any) => {
      if (res && res.loginImage) {
        this.logoUrl = res.loginImage;
      }
    });
  }

  get currentLang(): string {
    return this.translate.currentLang || this.translate.getDefaultLang() || localStorage.getItem('lang') || 'de';
  }

  setLanguage(lang: string): void {
    this.translate.use(lang);
    localStorage.setItem('lang', lang);
  }

  ngOnInit () {
    this.hash = this.route.snapshot.queryParamMap.get('hash');
    this.email = this.route.snapshot.queryParamMap.get('email');
    this.resetPasswordForm = this.formBuilder.group({
      email: new FormControl({value: null, disabled: true}, Validators.required) ,
      password: [ '' , [Validators.required, passwordRequirementsValidator] ] ,
      passwordConfirm: [ '' , Validators.required ]
    });

    this.resetPasswordForm.valueChanges.subscribe(() => {
      this.onResetPasswordFormValuesChanged();
    });
    this.resetPasswordForm.setValue({email: this.email, password: '', passwordConfirm: ''});
  }

  onResetPasswordFormValuesChanged () {
    for (const field in this.resetPasswordFormErrors) {
      if (this.resetPasswordFormErrors.hasOwnProperty(field)) {
        continue;
      }

      // Clear previous errors
      this.resetPasswordFormErrors[ field ] = {};

      // Get the control
      const control = this.resetPasswordForm.get(field);

      if (control && control.dirty && !control.valid) {
        this.resetPasswordFormErrors[ field ] = control.errors;
      }
    }
  }

  changePass () {
    this.resetPasswordForm.value.email = this.hash;
    this.fuseConfig.changePass({hash: this.hash, password: this.resetPasswordForm.value.password}).pipe(map(
      (res) => {
        if (res[ 'error' ]) {
          // this.errMsg = res[ 'error' ];
        } else {
          console.log('Done');
          this.router.navigate(['/pages/auth/login']);
        }
      })).subscribe();
  }

    get passwordValue(): string {
      return this.resetPasswordForm.get('password')?.value || '';
    }

    get hasMinLength(): boolean {
      return this.passwordValue.length >= 12;
    }

    get hasNumber(): boolean {
      return /\d/.test(this.passwordValue);
    }

    get hasSpecialChar(): boolean {
      return /[^a-zA-Z0-9]/.test(this.passwordValue);
    }

    showPass() {
      let pass: any = document.getElementById('password');
      let confirmPass: any = document.getElementById('confirmPassword');
      if (pass) {
        pass.type = 'text';
      }
      if (confirmPass) {
        confirmPass.type = 'text';
      }
      setTimeout(() => {
        if (pass) {
          pass.type = 'password';
        }
        if (confirmPass) {
          confirmPass.type = 'password';
        }
      }, 10000);
    }
}

